import React from 'react';
import { Phone, FileText, CheckCircle, ExternalLink, Heart } from 'lucide-react';
export function MedicalCardInfoPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-2949">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-2950">
        <div className="container mx-auto px-4" data-id="element-2951">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-2952">
            Medical Certificate
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-2953">
            Physical Qualifications for Commercial Motor Vehicle Drivers
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-2954">
        <div className="max-w-4xl mx-auto" data-id="element-2955">
          {/* General Information */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-2956">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-2957">
              General Information
            </h2>

            <div className="space-y-6" data-id="element-2958">
              <div className="bg-red-50 border-l-4 border-red-500 p-6" data-id="element-2959">
                <h3 className="font-bold text-gray-900 mb-3" data-id="element-2960">
                  §391.11(a) Basic Requirement
                </h3>
                <p className="text-gray-700" data-id="element-2961">
                  A person shall not drive a commercial motor vehicle unless
                  he/she is qualified to drive a commercial motor vehicle.
                  Except as provided in §391.63, a motor carrier shall not
                  require or permit a person to drive a commercial motor vehicle
                  unless that person is qualified to drive a commercial motor
                  vehicle.
                </p>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-2962">
                <h3 className="font-bold text-gray-900 mb-4" data-id="element-2963">
                  §391.11(b) Qualification Requirements
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-2964">
                  Except as provided in Subpart G of this part, a person is
                  qualified to drive a motor vehicle if he/she:
                </p>
              </div>

              <div className="space-y-4" data-id="element-2965">
                <div className="bg-white border-2 border-blue-500 rounded-lg p-6" data-id="element-2966">
                  <div className="flex items-start" data-id="element-2967">
                    <span className="bg-blue-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-2968">
                      (1)
                    </span>
                    <div data-id="element-2969">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-2970">
                        Age Requirement
                      </p>
                      <p className="text-gray-700" data-id="element-2971">
                        Is at least <strong data-id="element-2972">21 years old</strong>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-green-500 rounded-lg p-6" data-id="element-2973">
                  <div className="flex items-start" data-id="element-2974">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-2975">
                      (2)
                    </span>
                    <div data-id="element-2976">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-2977">
                        English Language Proficiency
                      </p>
                      <p className="text-gray-700" data-id="element-2978">
                        Can read and speak the English language sufficiently to:
                      </p>
                      <ul className="mt-2 space-y-1 text-gray-700 ml-4" data-id="element-2979">
                        <li data-id="element-2980">• Converse with the general public</li>
                        <li data-id="element-2981">
                          • Understand highway traffic signs and signals in
                          English
                        </li>
                        <li data-id="element-2982">• Respond to official inquiries</li>
                        <li data-id="element-2983">• Make entries on reports and records</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-yellow-500 rounded-lg p-6" data-id="element-2984">
                  <div className="flex items-start" data-id="element-2985">
                    <span className="bg-yellow-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-2986">
                      (3)
                    </span>
                    <div data-id="element-2987">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-2988">
                        Experience & Training
                      </p>
                      <p className="text-gray-700" data-id="element-2989">
                        Can, by reason of experience, training, or both, safely
                        operate the type of commercial motor vehicle he/she
                        drives
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-red-500 rounded-lg p-6" data-id="element-2990">
                  <div className="flex items-start" data-id="element-2991">
                    <span className="bg-red-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-2992">
                      (4)
                    </span>
                    <div data-id="element-2993">
                      <p className="font-bold text-gray-900 mb-2 flex items-center" data-id="element-2994">
                        <Heart className="mr-2 text-red-600" size={20} data-id="element-2995" />
                        Physical Qualifications
                      </p>
                      <p className="text-gray-700" data-id="element-2996">
                        Is physically qualified to drive a commercial motor
                        vehicle in accordance with{' '}
                        <strong data-id="element-2997">
                          Subpart E — Physical Qualifications and Examinations
                        </strong>{' '}
                        of this part
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-purple-500 rounded-lg p-6" data-id="element-2998">
                  <div className="flex items-start" data-id="element-2999">
                    <span className="bg-purple-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3000">
                      (5)
                    </span>
                    <div data-id="element-3001">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3002">
                        Valid License
                      </p>
                      <p className="text-gray-700" data-id="element-3003">
                        Has a currently valid commercial motor vehicle
                        operator's license issued only by{' '}
                        <strong data-id="element-3004">one State or jurisdiction</strong>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-indigo-500 rounded-lg p-6" data-id="element-3005">
                  <div className="flex items-start" data-id="element-3006">
                    <span className="bg-indigo-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3007">
                      (6)
                    </span>
                    <div data-id="element-3008">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3009">
                        Violation Records
                      </p>
                      <p className="text-gray-700" data-id="element-3010">
                        Has prepared and furnished the motor carrier that
                        employs him/her with the list of violations or the
                        certificate as required by §391.27
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-orange-500 rounded-lg p-6" data-id="element-3011">
                  <div className="flex items-start" data-id="element-3012">
                    <span className="bg-orange-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3013">
                      (7)
                    </span>
                    <div data-id="element-3014">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3015">
                        Not Disqualified
                      </p>
                      <p className="text-gray-700" data-id="element-3016">
                        Is not disqualified to drive a commercial motor vehicle
                        under the rules in §391.15
                      </p>
                    </div>
                  </div>
                </div>

                <div className="bg-white border-2 border-teal-500 rounded-lg p-6" data-id="element-3017">
                  <div className="flex items-start" data-id="element-3018">
                    <span className="bg-teal-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3019">
                      (8)
                    </span>
                    <div data-id="element-3020">
                      <p className="font-bold text-gray-900 mb-2" data-id="element-3021">
                        Road Test Certification
                      </p>
                      <p className="text-gray-700" data-id="element-3022">
                        Has successfully completed a driver's road test and has
                        been issued a certificate of driver's road test in
                        accordance with §391.31, or has presented an operator's
                        license or certificate of road test which the motor
                        carrier has accepted as equivalent to a road test in
                        accordance with §391.33
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Key Requirements Summary */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3023">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3024">
              8 Key Qualification Requirements
            </h2>

            <div className="grid md:grid-cols-2 gap-4" data-id="element-3025">
              <div className="bg-white/10 rounded-lg p-4" data-id="element-3026">
                <p className="font-bold mb-1" data-id="element-3027">1. Age</p>
                <p className="text-sm text-gray-200" data-id="element-3028">At least 21 years old</p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3029">
                <p className="font-bold mb-1" data-id="element-3030">2. English Proficiency</p>
                <p className="text-sm text-gray-200" data-id="element-3031">
                  Read, speak, understand signs
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3032">
                <p className="font-bold mb-1" data-id="element-3033">3. Experience/Training</p>
                <p className="text-sm text-gray-200" data-id="element-3034">Safely operate CMV type</p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3035">
                <p className="font-bold mb-1" data-id="element-3036">4. Physical Qualifications</p>
                <p className="text-sm text-gray-200" data-id="element-3037">
                  Meet Subpart E requirements
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3038">
                <p className="font-bold mb-1" data-id="element-3039">5. Valid License</p>
                <p className="text-sm text-gray-200" data-id="element-3040">
                  One State/jurisdiction only
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3041">
                <p className="font-bold mb-1" data-id="element-3042">6. Violation Records</p>
                <p className="text-sm text-gray-200" data-id="element-3043">
                  Furnished to employer (§391.27)
                </p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3044">
                <p className="font-bold mb-1" data-id="element-3045">7. Not Disqualified</p>
                <p className="text-sm text-gray-200" data-id="element-3046">Per §391.15 rules</p>
              </div>

              <div className="bg-white/10 rounded-lg p-4" data-id="element-3047">
                <p className="font-bold mb-1" data-id="element-3048">8. Road Test</p>
                <p className="text-sm text-gray-200" data-id="element-3049">
                  Certificate per §391.31/§391.33
                </p>
              </div>
            </div>
          </div>

          {/* Important Resources */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3050">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3051">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3052" />
              Important Resources
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-3053">
              <a href="http://www.fmcsa.dot.gov/documents/safetyprograms/Medical-Report.pdf" target="_blank" rel="noopener noreferrer" className="bg-blue-50 hover:bg-blue-100 border-2 border-blue-500 rounded-lg p-6 transition-colors group" data-id="element-3054">
                <div className="flex items-start mb-3" data-id="element-3055">
                  <FileText className="text-blue-600 mr-3 flex-shrink-0" size={24} data-id="element-3056" />
                  <h3 className="font-bold text-gray-900 group-hover:text-blue-600 transition-colors" data-id="element-3057">
                    Medical Examination Form
                  </h3>
                </div>
                <p className="text-sm text-gray-700 mb-3" data-id="element-3058">
                  Official FMCSA medical examination form for commercial drivers
                </p>
                <div className="flex items-center text-blue-600 font-semibold" data-id="element-3059">
                  <span className="mr-2" data-id="element-3060">Download PDF</span>
                  <ExternalLink size={16} data-id="element-3061" />
                </div>
              </a>

              <a href="http://www.fmcsa.dot.gov/rules-regulations/topics/medical/exemptions.htm" target="_blank" rel="noopener noreferrer" className="bg-green-50 hover:bg-green-100 border-2 border-green-500 rounded-lg p-6 transition-colors group" data-id="element-3062">
                <div className="flex items-start mb-3" data-id="element-3063">
                  <FileText className="text-green-600 mr-3 flex-shrink-0" size={24} data-id="element-3064" />
                  <h3 className="font-bold text-gray-900 group-hover:text-green-600 transition-colors" data-id="element-3065">
                    Driver Exemption Programs
                  </h3>
                </div>
                <p className="text-sm text-gray-700 mb-3" data-id="element-3066">
                  Information on medical exemptions and waiver programs
                </p>
                <div className="flex items-center text-green-600 font-semibold" data-id="element-3067">
                  <span className="mr-2" data-id="element-3068">View Information</span>
                  <ExternalLink size={16} data-id="element-3069" />
                </div>
              </a>

              <a href="http://www.fmcsa.dot.gov/rules-regulations/topics/medical/spepackage.htm" target="_blank" rel="noopener noreferrer" className="bg-purple-50 hover:bg-purple-100 border-2 border-purple-500 rounded-lg p-6 transition-colors group" data-id="element-3070">
                <div className="flex items-start mb-3" data-id="element-3071">
                  <FileText className="text-purple-600 mr-3 flex-shrink-0" size={24} data-id="element-3072" />
                  <h3 className="font-bold text-gray-900 group-hover:text-purple-600 transition-colors" data-id="element-3073">
                    Skill Performance Evaluation (SPE)
                  </h3>
                </div>
                <p className="text-sm text-gray-700 mb-3" data-id="element-3074">
                  SPE program for drivers with certain physical conditions
                </p>
                <div className="flex items-center text-purple-600 font-semibold" data-id="element-3075">
                  <span className="mr-2" data-id="element-3076">Learn More</span>
                  <ExternalLink size={16} data-id="element-3077" />
                </div>
              </a>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3078">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3079">Key Takeaways</h2>

            <div className="space-y-3" data-id="element-3080">
              <div className="flex items-start" data-id="element-3081">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3082" />
                <span data-id="element-3083">
                  All CMV drivers must be qualified under §391.11 requirements
                </span>
              </div>
              <div className="flex items-start" data-id="element-3084">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3085" />
                <span data-id="element-3086">Minimum age: 21 years old for interstate commerce</span>
              </div>
              <div className="flex items-start" data-id="element-3087">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3088" />
                <span data-id="element-3089">
                  English language proficiency required for safety communication
                </span>
              </div>
              <div className="flex items-start" data-id="element-3090">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3091" />
                <span data-id="element-3092">
                  Physical qualifications must meet Subpart E standards
                </span>
              </div>
              <div className="flex items-start" data-id="element-3093">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3094" />
                <span data-id="element-3095">Valid CDL from only one State or jurisdiction</span>
              </div>
              <div className="flex items-start" data-id="element-3096">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3097" />
                <span data-id="element-3098">Violation records must be furnished to employer</span>
              </div>
              <div className="flex items-start" data-id="element-3099">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3100" />
                <span data-id="element-3101">Must not be disqualified under §391.15</span>
              </div>
              <div className="flex items-start" data-id="element-3102">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3103" />
                <span data-id="element-3104">
                  Road test certification required (§391.31 or §391.33)
                </span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-3105">
            <h2 className="text-3xl font-bold mb-4" data-id="element-3106">
              Need Help with Medical Certification?
            </h2>
            <p className="text-xl mb-6" data-id="element-3107">
              Expert guidance on DOT medical requirements and physical
              qualifications
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-3108">
              <Phone className="mr-3" size={24} data-id="element-3109" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-3110">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}